import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Inbound from 'Assets/images/AppLogo/inbound.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Inbound + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCInbound(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
